import { BreadCrumb } from '../../models/BreadCrumb';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'top-nav-crumbs',
    templateUrl: './topnavcrumbs.component.html',
    styleUrls: ['./topnavcrumbs.component.css']
})
export class TopNavBarCrumbs implements OnInit {

    @Input('Title') Title: string;
    @Input('CrumbsOverwrite') CrumbsOverwrite: Array<BreadCrumb>;
    @Input('HideBreadCrumbs') HideBreadCrumbs: boolean = false;

    Crumbs: Array<BreadCrumb>;

    constructor(private router: Router) {
    }

    ngOnInit() {
        this.CreateBreadCrumbs();
    }

    CreateBreadCrumbs() {
        this.Crumbs = new Array<BreadCrumb>();
        let routes = this.router.url.split('/');

        for (let i = 0; i < routes.length; i++) {

            let currentItem = routes[i];
            if (currentItem == '') {
                continue;
            }


            let NewCrumb = new BreadCrumb();

            
            // href and tooltip
            if (i == routes.length - 1) {
                NewCrumb.Link = '#';
                NewCrumb.Tooltip = '';
                NewCrumb.Title = this.Title;

            } else {
                NewCrumb.Title = currentItem;
                NewCrumb.Link = this.GetRouteSection(routes, i);
                NewCrumb.Tooltip = 'Navigate to ' + NewCrumb.Title;
            }


            // add to array
            this.Crumbs.push(this.GetCrumbOverwrite(i, NewCrumb, (i == routes.length - 1)));
        }

        // set title to last item if title is empty
        if (!this.Title) {
            let title = this.Crumbs[this.Crumbs.length - 1].Title;
            this.Title = title.charAt(0).toUpperCase() + title.substr(1).toLowerCase();
        }
    }

    private GetCrumbOverwrite(section: number, originalValue: BreadCrumb, IsLast: boolean): BreadCrumb {

        if (!this.CrumbsOverwrite) {
            return originalValue;
        }

        let item: BreadCrumb;

        // match overwrite
        if (IsLast) {
            // we have last
            // search with index 0 or undefined
            item = this.CrumbsOverwrite.find((item) => item.Index == 0 || !item.Index || item.Index == this.Crumbs.length + 1);
        } else {
            // search item
            item = this.CrumbsOverwrite.find((item) => item.Index === section);

        }

        if (!item) {
            return originalValue;
        }
        // item = items[0];


        // we have a overwirte
        if (item.Title) {
            // title
            originalValue.Title = item.Title;
        }

        if (item.Link) {
            // href
            originalValue.Link = item.Link;
        }

        if (item.Tooltip) {
            // tooltip
            originalValue.Tooltip = item.Tooltip;
        }


        return originalValue;
    }

    private GetRouteSection(routeArray: string[], section: number): string {

        let newRoute: string = '';

        for (let i = 0; i < section + 1; i++) {
            let thisSection = routeArray[i];

            if (thisSection == '' || thisSection == 'undefined') {
                continue;
            }

            newRoute += '/' + thisSection;
        }

        return newRoute;
    }

}
